import { render, staticRenderFns } from "./shuttleOABox.vue?vue&type=template&id=4ca47317&scoped=true&"
import script from "./shuttleOABox.vue?vue&type=script&lang=ts&"
export * from "./shuttleOABox.vue?vue&type=script&lang=ts&"
import style1 from "./shuttleOABox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca47317",
  null
  
)

export default component.exports